import React, { Component } from 'react';
import $ from 'jquery';
import CardsListModal from './CardsListModal';
import AccountListModal from './AccountListModal';

class PaymentCreditCardsModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closePaymentCreditCards = async () => {
        $('#paymentCreditCardsModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#paymentCreditCardsModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const { 
            model,
            selectTabCard,
            addCreditCard,
            deleteCard,
            openCard,
            OpenCuentaMayorCredit,
            validateCardNum,
            changeCardNum,
            changeCardValid,
            changeValidateValidCard,
            changeOwnerIdNum,
            changeOwnerPhone,
            keydownHandler,
            changeCreditSum,
            changeTransfersRef,
            changeVoucherNum,
            changeCreditType,
            changeCreditSumOne,
            selectCardList,
            cardList,
            cleanCardList,
            ShowAccountsModalCredit,
            accountsCredit,
            SelectAccountListCredit,
            cleanDataAccountsCredit,
        } = this.props;
        
        return (
            <div>
                <div className="modal fade bd-example-modal-lg bgtransparent" role="dialog" id="paymentCreditCardsModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document" style={{ width: 800, maxWidth: 800 }}>
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">Tarjeta de crédito</h4>
                                <button type="button" className="close" onClick={this.closePaymentCreditCards} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-10">
                                            <div className="nav nav-tabs" id="myTabCards" role="tablist">
                                                {!!model.PaymentsCreditCards && model.PaymentsCreditCards.map((card, index) => {
                                                    return (
                                                        <>
                                                            <span
                                                                className={`nav-item nav-link${card.isSelected ? " active" : ""}`}
                                                                id={`card${index}-tab`}
                                                                data-bs-toggle="tab"
                                                                data-bs-target={`#card${index}`}
                                                                role="tab"
                                                                aria-controls={`card${index}`}
                                                                // eslint-disable-next-line jsx-a11y/aria-proptypes
                                                                aria-selected={`${card.isSelected ? true : false}`}
                                                                onClick={() => selectTabCard(index)}>
                                                                {card.CardName || `Tarjeta ${index + 1} `}
                                                                <i className="fa fa-times" style={{ marginLeft: 7 }} aria-hidden="true" onClick={() => deleteCard(index)} />
                                                            </span>
                                                        </>
                                                    )
                                                })}

                                                <li className="nav-item" role="presentation">
                                                    <button
                                                        className="nav-link"
                                                        id={`addCard-tab`}
                                                        data-bs-toggle="tab"
                                                        data-bs-target={`#addCard`}
                                                        type="button"
                                                        role="tab"
                                                        aria-controls={`addCard`}
                                                        aria-selected="false"
                                                        onClick={addCreditCard}>
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                    </button>
                                                </li>
                                            </div>

                                            <div className="tab-content" id="myTabContentCard" style={{ textAlign: 'left' }}>
                                                {!!model.PaymentsCreditCards &&
                                                    model.PaymentsCreditCards.map((card, index) => {
                                                        return (
                                                            <div
                                                                className={`tab-pane fade${card.isSelected ? " show active" : ""}`}
                                                                id={`card${index}`}
                                                                role="tabpanel"
                                                                aria-labelledby={`card${index}-tab`}>

                                                                {/* Nombre de tarjeta */}
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre de tarjeta</span>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control input-sm"
                                                                        id="txtCardName"
                                                                        disabled="true"
                                                                        value={card.CardName || ''}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                                        className="input-group-text"
                                                                        onClick={() => openCard(index)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                </div>

                                                                {/*Cuenta de Mayor*/}
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Cuenta de Mayor</span>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control input-sm"
                                                                        id="txtName"
                                                                        disabled="true"
                                                                        value={card.CreditAcct || ''}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                                        className="input-group-text"
                                                                        onClick={() => OpenCuentaMayorCredit(0, 2)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                </div>

                                                                {/*Numero de tarjeta*/}
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Número de tarjeta</span>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control btn-outline-secondary"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            borderColor: '#ced4da',
                                                                            color: '#000',
                                                                        }}
                                                                        maxlength="4"
                                                                        value={card.CrCardNum || ''}
                                                                        onBlur={(event) => validateCardNum(event.nativeEvent.target.value, index)}
                                                                        onChange={(event) => changeCardNum(event.nativeEvent.target.value, index)}
                                                                    />
                                                                </div>

                                                                {/*Válido hasta*/}
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Válido hasta</span>
                                                                    </div>
                                                                    <input
                                                                        type=" text"
                                                                        className="form-control btn-outline-secondary"
                                                                        placeholder='MM/AA'
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            borderColor: '#ced4da',
                                                                            color: '#000',
                                                                        }}
                                                                        maxlength="5"
                                                                        value={card.CardValid || ''}
                                                                        onChange={(event) => changeCardValid(event.nativeEvent.target.value, index)}
                                                                        onBlur={(event) => changeValidateValidCard(event.nativeEvent.target.value, index)}
                                                                    />
                                                                </div>

                                                                {/*Número de ID*/}
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Número de ID</span>
                                                                    </div>
                                                                    <input
                                                                        type=" text"
                                                                        className="form-control btn-outline-secondary"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            borderColor: '#ced4da',
                                                                            color: '#000',
                                                                        }}
                                                                        maxlength="15"
                                                                        value={card.OwnerIdNum || ''}
                                                                        onChange={(event) => changeOwnerIdNum(event.nativeEvent.target.value, index)}
                                                                    />
                                                                </div>

                                                                {/*Número de teléfono*/}
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Número de teléfono</span>
                                                                    </div>
                                                                    <input
                                                                        type=" text"
                                                                        className="form-control btn-outline-secondary"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            borderColor: '#ced4da',
                                                                            color: '#000',
                                                                        }}
                                                                        maxlength="20"
                                                                        value={card.OwnerPhone || ''}
                                                                        onChange={(event) => changeOwnerPhone(event.nativeEvent.target.value, index)}
                                                                    />
                                                                </div>

                                                                {/*Forma de pago*/}
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Forma de pago</span>
                                                                    </div>
                                                                    <input
                                                                        type=" text"
                                                                        className="form-control btn-outline-secondary"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            borderColor: '#ced4da',
                                                                            color: '#000',
                                                                        }}
                                                                        value={card.CrTypeCode || ''}
                                                                    />
                                                                </div>

                                                                {/*Importe vencido*/}
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Importe vencido</span>
                                                                    </div>
                                                                    <input
                                                                        type=" text"
                                                                        className="form-control btn-outline-secondary"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            borderColor: '#ced4da',
                                                                            color: '#000',
                                                                        }}
                                                                        maxlength="40"
                                                                        value={card.CreditSum || ''}
                                                                        onKeyPress={(event) => keydownHandler(event, index)}
                                                                        onChange={(event) => changeCreditSum(event.nativeEvent.target.value, index)}
                                                                    />
                                                                </div>

                                                                {/* Primer pago parcial
                                                                    <div className="input-group mb-3">
                                                                        <div className="input-group-prepend">
                                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Primer pago parcial</span>
                                                                        </div>
                                                                            <input
                                                                                type=" text"
                                                                                className="form-control btn-outline-secondary"
                                                                                disabled={action === 2 ? true : false}
                                                                                style={{
                                                                                    backgroundColor: 'transparent',
                                                                                    borderColor: '#ced4da',
                                                                                    color: '#000',
                                                                                }}
                                                                                value={model.TrsfrRef ? model.TrsfrRef : ''}
                                                                                onChange={changeTransfersRef}
                                                                            />
                                                                    </div> */}

                                                                {/*Cada pago adicional*/}
                                                                {/* <div className="input-group mb-3">
                                                                        <div className="input-group-prepend">
                                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Cada pago adicional</span>
                                                                        </div>
                                                                            <input
                                                                                type=" text"
                                                                                className="form-control btn-outline-secondary"
                                                                                disabled={action === 2 ? true : false}
                                                                                style={{
                                                                                    backgroundColor: 'transparent',
                                                                                    borderColor: '#ced4da',
                                                                                    color: '#000',
                                                                                }}
                                                                                value={model.TrsfrRef ? model.TrsfrRef : ''}
                                                                                onChange={changeTransfersRef}
                                                                            />
                                                                    </div> */}

                                                                {/*N° certific.retenc.impto*/}
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">N° certific.retenc.impto</span>
                                                                    </div>
                                                                    <input
                                                                        type=" text"
                                                                        className="form-control btn-outline-secondary"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            borderColor: '#ced4da',
                                                                            color: '#000',
                                                                        }}
                                                                        maxlength="20"
                                                                        value={card.VoucherNum || ''}
                                                                        onChange={(event) => changeVoucherNum(event.nativeEvent.target.value, index)}
                                                                    />
                                                                </div>

                                                                {/*Clase de operación*/}
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Clase de operación</span>
                                                                    </div>
                                                                    <select className="form-control"
                                                                        onChange={event => changeCreditType(event.nativeEvent.target.value, index)}
                                                                        value={card.CreditType}>
                                                                        <option value="S">Regular</option>
                                                                        <option value="I">Transacción de Internet</option>
                                                                        <option value="U">Transacción telefónica</option>
                                                                    </select>
                                                                </div>

                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>

                                            {/*total en trasferencia*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Total</span>
                                                </div>
                                                <input
                                                    type=" text"
                                                    className="form-control btn-outline-secondary"
                                                    disabled={true}
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000',
                                                        textAlign: "right",
                                                    }}
                                                    value={model.CreditSum}
                                                    onChange={changeCreditSumOne}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closePaymentCreditCards}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <CardsListModal
                    data = {cardList}
                    selectAccount={selectCardList}
                    cleanData = {cleanCardList}
                />

                { ShowAccountsModalCredit && (
                    <AccountListModal
                        data={accountsCredit}
                        selectAccount={SelectAccountListCredit}
                        cleanData={cleanDataAccountsCredit}
                    />
                )}
            </div>
        );
    }
}

export default PaymentCreditCardsModal;